import styled from "styled-components";
import Flex from "../box/Flex";
export const MAIN_NAV_WIDTH = 56;
export const StyledMainContainer = styled(Flex).withConfig({ displayName: "StyledMainContainer_APC-7281-productShell", componentId: "sc-opkk55" })(({ theme }) => ({
    background: theme.colors.apolloColorBackgroundDashboard,
    flexDirection: "column",
    height: "100%",
    width: "100%",
}));
//# sourceMappingURL=MainContainer.style.js.map